import ModalComponent from "..";
import { useAppSelector } from "../../../redux/hooks";
import { ModalCompProps } from "../../../utils/types";
import { Button } from "../../buttons/button";

export const BackUpCodesModal = ({
  open,
  handleClose,
  onSuccess,
}: ModalCompProps & {
  onSuccess: () => void;
}) => {
  const { backUpCodes } = useAppSelector((state) => state.auth);

  return (
    <ModalComponent
      open={open}
      handleClose={() => {
        handleClose();
      }}
      className=""
      dialogClassName=""
      closeOnOverlayClick
      showHeader
      title={"2FA Backup Codes"}
      subtitle={
        "Download your backup codes and keep there safe. If you lose access to your authentication device, you can use any of these codes to login to your account."
      }
      showIcon={true}
      iconType="check-two"
      showBackIcon={false}
      mobileAnchorBottom
      showCloseIcon={false}
    >
      <div className="flex flex-col gap-2.5">
        <main className="w-full rounded-lg border border-gray-100 py-[32px]">
          <div className="mx-auto grid w-[90%] grid-cols-2 justify-items-center gap-5 md:w-[324px]">
            {backUpCodes?.map((code, index) => (
              <p className="text-sm text-primary" key={index}>
                {code}
              </p>
            ))}
          </div>
        </main>
        <div className="col-span-full flex items-center justify-end gap-2">
          <Button
            text={"Close"}
            type="button"
            onClick={() => {
              handleClose();
            }}
            variation="plain-grey"
            className="max-w-fit"
          />
          <Button
            text={"Download backup codes"}
            type="submit"
            onClick={() => {
              if (!backUpCodes || backUpCodes.length === 0) return;

              const fileContent = backUpCodes.join("\n");
              const blob = new Blob([fileContent], { type: "text/plain" });
              const url = URL.createObjectURL(blob);

              const a = document.createElement("a");
              a.href = url;
              a.download = "2fa-backup-codes.txt";

              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(url);
            }}
            className="max-w-fit"
            loading={false}
            disabled={false}
            variation={"primary"}
          />
        </div>
      </div>
    </ModalComponent>
  );
};
